export default __webpack_public_path__ + "static/media/mathislife.501dee50.jpg";